import { createEntityAdapter } from "@reduxjs/toolkit";
import { MylocFile } from "./dataTypes";

export const fileAdapter = createEntityAdapter<MylocFile>({});
